import { useSelectedLayoutSegments } from 'next/navigation';

export const useLayoutSegmentsMatched = (segments: Array<string>) => {
	const selectedLayoutSegments = useSelectedLayoutSegments();

	return segments.some(
		path => selectedLayoutSegments.includes(path)
	);
};